import styled from 'styled-components';

export const NodeRow = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  width: 100%;
`;

export const NodeLabel = styled.span<{ $dimmed?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: ${({ $dimmed }) => ($dimmed ? 0.45 : 1)};
`;

/**
 * O olho só aparece no hover ou quando o nó está oculto/parcial — uma coluna de
 * olhos em toda linha compete visualmente com a hierarquia, que é o que a
 * árvore existe pra mostrar.
 */
export const VisibilityToggle = styled.button<{ $visible: boolean }>`
  flex-shrink: 0;
  margin-left: auto;
  display: flex;
  align-items: center;
  padding: 2px;
  border: none;
  background: none;
  cursor: pointer;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.15s;

  .ant-tree-node-content-wrapper:hover & {
    opacity: 1;
  }

  &:focus-visible {
    opacity: 1;
    outline: 1px solid ${({ theme }) => theme.colors.primary.primary};
    border-radius: 2px;
  }
`;

export const NodeCount = styled.span`
  flex-shrink: 0;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;
